module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.e5c8656.otf";